import { render, staticRenderFns } from "./application-validation-steps.vue?vue&type=template&id=00d472a5&"
import script from "./application-validation-steps.vue?vue&type=script&lang=ts&"
export * from "./application-validation-steps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports